import { Component, input, viewChild } from '@angular/core';
import { TranslatePipe } from '../../translation/translate.pipe';
import { SafePipe } from '../../pipes/safe.pipe';
import { NgClass } from '@angular/common';
import { AccordionDirective } from 'ngx-unificator/directives';

@Component({
    selector: 'app-accordion-button',
    templateUrl: './accordion-button.component.html',
    styleUrls: ['./accordion-button.component.scss'],
    imports: [NgClass, AccordionDirective, SafePipe, TranslatePipe]
})
export class AccordionButtonComponent {
  readonly accordion = viewChild(AccordionDirective);

  readonly text = input('');

  /**
   * If true use another styles for footer
   */
  readonly isFooter = input(false);
}

